/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MatrixCarePatient } from './MatrixCarePatient';
import {
    MatrixCarePatientFromJSON,
    MatrixCarePatientFromJSONTyped,
    MatrixCarePatientToJSON,
} from './MatrixCarePatient';
import type { MatrixCarePatientDetailsDocuments } from './MatrixCarePatientDetailsDocuments';
import {
    MatrixCarePatientDetailsDocumentsFromJSON,
    MatrixCarePatientDetailsDocumentsFromJSONTyped,
    MatrixCarePatientDetailsDocumentsToJSON,
} from './MatrixCarePatientDetailsDocuments';
import type { MatrixCarePatientDetailsExternalEhrPatient } from './MatrixCarePatientDetailsExternalEhrPatient';
import {
    MatrixCarePatientDetailsExternalEhrPatientFromJSON,
    MatrixCarePatientDetailsExternalEhrPatientFromJSONTyped,
    MatrixCarePatientDetailsExternalEhrPatientToJSON,
} from './MatrixCarePatientDetailsExternalEhrPatient';
import type { MatrixCarePatientDetailsUploadDocumentsRequest } from './MatrixCarePatientDetailsUploadDocumentsRequest';
import {
    MatrixCarePatientDetailsUploadDocumentsRequestFromJSON,
    MatrixCarePatientDetailsUploadDocumentsRequestFromJSONTyped,
    MatrixCarePatientDetailsUploadDocumentsRequestToJSON,
} from './MatrixCarePatientDetailsUploadDocumentsRequest';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetails
 */
export interface MatrixCarePatientDetails {
    /**
     * 
     * @type {MatrixCarePatient}
     * @memberof MatrixCarePatientDetails
     */
    patient?: MatrixCarePatient;
    /**
     * 
     * @type {MatrixCarePatientDetailsExternalEhrPatient}
     * @memberof MatrixCarePatientDetails
     */
    external_ehr_patient?: MatrixCarePatientDetailsExternalEhrPatient;
    /**
     * 
     * @type {MatrixCarePatientDetailsDocuments}
     * @memberof MatrixCarePatientDetails
     */
    documents?: MatrixCarePatientDetailsDocuments;
    /**
     * 
     * @type {MatrixCarePatientDetailsUploadDocumentsRequest}
     * @memberof MatrixCarePatientDetails
     */
    upload_documents_request?: MatrixCarePatientDetailsUploadDocumentsRequest;
}

/**
 * Check if a given object implements the MatrixCarePatientDetails interface.
 */
export function instanceOfMatrixCarePatientDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MatrixCarePatientDetailsFromJSON(json: any): MatrixCarePatientDetails {
    return MatrixCarePatientDetailsFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient': !exists(json, 'patient') ? undefined : MatrixCarePatientFromJSON(json['patient']),
        'external_ehr_patient': !exists(json, 'external_ehr_patient') ? undefined : MatrixCarePatientDetailsExternalEhrPatientFromJSON(json['external_ehr_patient']),
        'documents': !exists(json, 'documents') ? undefined : MatrixCarePatientDetailsDocumentsFromJSON(json['documents']),
        'upload_documents_request': !exists(json, 'upload_documents_request') ? undefined : MatrixCarePatientDetailsUploadDocumentsRequestFromJSON(json['upload_documents_request']),
    };
}

export function MatrixCarePatientDetailsToJSON(value?: MatrixCarePatientDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient': MatrixCarePatientToJSON(value.patient),
        'external_ehr_patient': MatrixCarePatientDetailsExternalEhrPatientToJSON(value.external_ehr_patient),
        'documents': MatrixCarePatientDetailsDocumentsToJSON(value.documents),
        'upload_documents_request': MatrixCarePatientDetailsUploadDocumentsRequestToJSON(value.upload_documents_request),
    };
}

